/*
  Steps of the invitation acceptance that do not depend on the DOM nor on the server,
  kept apart from pageset_nc.ts to be unit tested.
*/

/** what identifies the invitation of a link: its id and its token */
export interface InvitationLink {
  iid?: string;
  v?: string;
  /** the email or login the invited user typed */
  identifier?: string;
}

/** the query string keeping the invitation while the user goes through the sign up pages */
export function invitationUrlParams(invitation: InvitationLink): string {
  return "?iid="+encodeURIComponent(invitation.iid)+"&v="+encodeURIComponent(invitation.v)+(invitation.identifier?"&identifier="+encodeURIComponent(invitation.identifier):"");
}

export interface SignUpOnInviteSteps {
  /** rejects when no account matches the identifier and the password */
  login: () => Promise<unknown>;
  /** for an account that already exists */
  acceptInvitation: () => unknown;
  /** for a new account, the invitation is accepted along with the account set up */
  createAccountAndAcceptInvitation: () => unknown;
}

/** the invitee typed an identifier and a password: log in if the account exists, create it otherwise */
export async function signUpOnInvite(steps: SignUpOnInviteSteps): Promise<void> {
  try{
    await steps.login();
  }catch(e){
    await steps.createAccountAndAcceptInvitation();
    return;
  }
  //the account already exists, the login worked
  steps.acceptInvitation();
}
